export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/e0c8222213835001b9a8c2c6f93acb8a.png)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 text-center px-6">
        <div className="mb-1 md:mb-4">
          <h1 className="text-white text-7xl md:text-8xl font-bold mb-3 tracking-tight">
            Spring Sun Bowl
          </h1>
          <p className="text-amber-300 text-4xl md:text-5xl font-light">置くだけ簡単スプサンボウル</p>
        </div>
        
        <button
          onClick={() => scrollToSection('lineup')}
          className="mt-2 md:mt-8 inline-flex items-center px-10 py-5 bg-gradient-to-r from-amber-500 to-amber-600 text-gray-900 font-medium text-lg rounded-full hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          製品を見る
          <span className="ml-3 w-8 h-8 bg-white rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-gray-900"></i>
          </span>
        </button>

        <p className="mt-4 md:mt-8 max-w-2xl mx-auto text-white/90 text-lg md:text-2xl leading-relaxed">
          Spring Sun Bowlは誰でもドバイのシーシャを立ちあげることができる製品です。職人がいない・シーシャを立ちあげることができない店舗でも簡単に立ちあげることが可能になる製品になります。ジューシー・簡単・シルキーな煙が特徴です。
        </p>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}